"use client";
import { useState } from "react";
import Link from "next/link";
import Container from "./Container";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
export default function Navgation(): React.ReactElement {
  const linkCss = `hover:underline-offset-8 hover:underline hover:decoration-red-600 hover:decoration-4
    active:underline-offset-8 active:underline active:decoration-red-600 active:decoration-4
    focus:underline-offset-8 focus:underline focus:decoration-red-600 focus:decoration-4 whitespace-nowrap`;
  const [showNavi, setShowNavi] = useState<boolean>(false);
  return (
    <nav className="bg-white fixed top-0 left-0 w-full border-b-red-600 border-b-solid border-b-2 lg:border-b-4 lg:bg-skyline bg-no-repeat bg-bottom-left z-10">
      <Container className="py-5 lg:py-8 relative lg:static col-start-2 col-span-10">
        <input
          type="checkbox"
          id="menu-toggle"
          className="hidden"
          checked={showNavi}
          onChange={() => setShowNavi(!showNavi)}
        />
        <label
          htmlFor="menu-toggle"
          className="text-black absolute right-0 top-2 lg:static lg:hidden cursor-pointer"
        >
          <CloseIcon id="menu-close" />
          <MenuIcon id="menu-open" />
          <span className="sr-only">
            Navigationsmenü öffnen oder schliessen
          </span>
        </label>
        <ul
          className="lg:flex lg:justify-center text-black lg:visible"
          id="menu"
        >
          <li className="px-5 mb-4 lg:mb-0">
            <Link
              href="/"
              className={linkCss}
              onClick={() => setShowNavi(false)}
            >
              HOMEPAGE
            </Link>
          </li>
          <li className="px-5 mb-4 lg:mb-0 lg:relative group">
            <span className="cursor-pointer flex align-middle">
              ÜBER MICH{" "}
              <KeyboardArrowDownIcon className="invisible lg:visible" />
            </span>
            <ul className="p-2 lg:absolute top-6 bg-white lg:shadow-lg lg:opacity-0 lg:invisible lg:group-hover:visible lg:group-hover:opacity-100 transition-all duration-300">
              <li className="p-2">
                <Link
                  href="/ueber-mich/politik"
                  className={linkCss}
                  onClick={() => setShowNavi(false)}
                >
                  POLITISCHE ZIELE
                </Link>
              </li>
              <li className="p-2">
                <Link
                  href="/ueber-mich/persoenlich"
                  className={linkCss}
                  onClick={() => setShowNavi(false)}
                >
                  PERSÖNLICHES
                </Link>
              </li>
            </ul>
          </li>
          <li className="px-5 mb-4 lg:mb-0 lg:relative group">
            <span className="cursor-pointer flex align-middle">
              AKTUELLES{" "}
              <KeyboardArrowDownIcon className="invisible lg:visible" />
            </span>
            <ul className="p-2 lg:absolute top-6 bg-white lg:shadow-lg lg:opacity-0 lg:invisible lg:group-hover:visible lg:group-hover:opacity-100 transition-all duration-300">
              <li className="p-2">
                <Link
                  href="/aktuelles/termine"
                  className={linkCss}
                  onClick={() => setShowNavi(false)}
                >
                  TERMINE
                </Link>
              </li>
              <li className="p-2">
                <Link
                  href="/aktuelles/medienmitteilungen"
                  className={linkCss}
                  onClick={() => setShowNavi(false)}
                >
                  MEDIENMITTEILUNGEN
                </Link>
              </li>
            </ul>
          </li>
          <li className="px-5 mb-4 lg:mb-0">
            <Link
              href="/spenden"
              className={linkCss}
              onClick={() => setShowNavi(false)}
            >
              SPENDEN
            </Link>
          </li>
        </ul>
      </Container>
    </nav>
  );
}
